import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalP2pDowloadQRCardsService } from 'app/manage-p2p/services/modal-p2p-dowload-qr-cards/modal-p2p-dowload-qr-cards.service';

@Component({
  selector: 'app-p2p-download-qr-cards',
  standalone: true,
  imports: [],
  templateUrl: './p2p-download-qr-cards.component.html',
  styleUrl: './p2p-download-qr-cards.component.scss'
})
export class P2pDownloadQrCardsComponent implements OnInit, AfterViewInit {
  @ViewChild('qrCardPreviewObject', { static: true }) qrCardPreviewObject: ElementRef;
  @Input() data

  public header = 'Download Fundraiser QR Codes';
  public subheader = 'Download and share 3.5x2“ Landscape Cards with QR codes for all fundraisers. Champions may use them to accept donations.';
  public instructions = 'Print it on letter size paper with scale set to 100%. Conform to the size of Avery 5371 sticker paper or similar template. Each page has 10 cards.';

  constructor(
    public modalP2pDowloadQRCardsService: ModalP2pDowloadQRCardsService,
  ){}

  ngOnInit(): void {
    this.setHeaders(this.data);
  }

  ngAfterViewInit(): void {
    this.manipulateElement(this.data.fileName);
  }

  manipulateElement(fileName: string): void {
    this.qrCardPreviewObject.nativeElement.setAttribute('data', fileName);
    const viewerClone = this.qrCardPreviewObject.nativeElement.cloneNode(true);
    const viewerParent = this.qrCardPreviewObject.nativeElement.parentNode;
    viewerParent.removeChild(this.qrCardPreviewObject.nativeElement);
    viewerParent.appendChild(viewerClone);
  }

  setHeaders({options}): void {
    if(!options) {
      return;
    }
    this.header = options.header ?? this.header;
    this.subheader = options.subheader ?? this.subheader;
    this.instructions = options.instructions ?? this.instructions;
  }

  close() {
    this.modalP2pDowloadQRCardsService.close();
  }
}